module.exports = __webpack_public_path__ + "img/shoppingBagYellow.2888881b.jpg";